import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const airTicketsSlice = createSlice({
  name: "airTickets",

  initialState: { airTickets: [], airticketLoader: false },
  reducers: {
    setAllAirTickets: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.airTickets = payload;
    },
    setAirticketLaoder: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.airticketLoader = payload;
    },
    resetAllAirTickets: (state) => {
      state.airTickets = [];
    },
  },
});

export const { setAllAirTickets, resetAllAirTickets, setAirticketLaoder } =
  airTicketsSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default airTicketsSlice.reducer;
